/**
 * Shared layout classes for React admin pages with dealer/site scope trees.
 * Semantic CSS in styles.css — avoids Tailwind v4 content-scan gaps on complex grids.
 */

/** Page root inside AppShell main — fills the centered shell column (max-w-7xl). */
export const adminPageRootClass = 'admin-page-root';

export const adminScopePageGridClass = 'admin-scope-page-grid';

/** Wrap scope tree column on master–detail pages (use on ScopeTree parent if needed). */
export const adminScopeTreeSlotClass = 'admin-scope-tree-slot';

/** Scope tree card + scroll list (stretch with main column at lg+, capped to viewport; internal scroll when long). */
export const adminScopeTreePanelClass = 'admin-scope-tree-panel';
export const adminScopeTreePanelBodyClass = 'admin-scope-tree-panel-body';
export const adminScopeTreeListClass = 'admin-scope-tree-list';

export const adminScopePageMainClass = 'admin-scope-page-main';

/** SOP workflow / library shells (column count set per page at xl). */
export const adminScopePageGridBaseClass = 'admin-scope-page-grid-base';

/** Parent of TabsList on Sites Admin. Overflow stays visible; tabs wrap instead of scrolling. */
export const adminScrollableTabsWrapClass = 'admin-scrollable-tabs-wrap';

export const adminScrollableTabsListClass = 'admin-scrollable-tabs-list';

export const adminScrollableTabTriggerClass = 'admin-scrollable-tab-trigger';
